module.exports = __webpack_public_path__ + "static/img/linkedin.1af8d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linkedin.png
// module id = gMTf
// module chunks = 1